import angular from 'angular';
class LigneAnnuaireService {
    /* @ngInject */
    constructor(LigneAnnuaireDA) {
        this.ligneAnnuaireDA = LigneAnnuaireDA;
    }

    checkPdpConflict(entityType, entityId, startDate, endDate){
        return this.ligneAnnuaireDA.checkPdpConflict(entityType, entityId, startDate, endDate);
    }
}
angular.module('app.principal').service('LigneAnnuaireService', LigneAnnuaireService);